<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">发货通知单</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="发货通知单">
        <el-input class="form-input" v-model="Search.OrderCode" placeholder="请输入发货通知单" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="客户订单号">
        <el-input class="form-input" v-model="Search.PartnerCode" placeholder="请输入客户订单号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="物流类型">
        <el-select class="form-input" v-model="Search.ShipmentMethod" placeholder="租赁单/代管单/物流销售单" clearable  @keyup.enter.native="handleSearch">
          <el-option label="森普瑞物流" value="internal"></el-option>
          <el-option label="第三方物流" value="external"></el-option>
          <el-option label="客户自提" value="none"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货时间">
      <el-date-picker
        v-model="Search.OrderDateDuration"
        type="daterange"
        align="right"
        placeholder="选择日期范围" @keyup.enter.native="handleSearch">
      </el-date-picker>
    </el-form-item>
          <el-button @click="handleSearch" :loading="IsLoading" element-loading-text="拼命加载中" type="primary">查询</el-button>
          <el-button type="primary"  @click="goto({name:'TrustList'})" >新建发货通知单</el-button>
    </el-form>
    <div class="main-content" slot="main-content">
      <el-tabs class="tab" :value="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待确认" name="draft"></el-tab-pane>
        <el-tab-pane label="待发货" name="reserved"></el-tab-pane>
        <el-tab-pane label="已发货" name="shipped"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancelled"></el-tab-pane>
      </el-tabs> 
      <complex-grid :config="tableConfig" v-loading.body="IsLoading" :data="tableData" slot="main-content">
        <template slot="sub-header" scope="props">
          <el-col :span="20">
            <span style="min-width: 136px">{{props.row.OrderDate | date('YYYY-MM-DD HH:mm:ss')}}</span>
            <span style="margin-left: 20px">发货通知单:{{props.row.Code}}</span>
            <span style="margin-left: 20px">客户订单号：{{props.row.Partner.Code}}</span>
            <span style="margin-left: 20px">发货来源：{{props.row.OriginalOrderType | OrderSource}}</span>
            <span style="margin-left: 20px">配送类型: {{props.row.DeliveryType | ChangeDeliveryType}}</span>
          </el-col>
          <el-col :span="4" class="text-right">状态：<span class="status">{{props.row.State | NormalState}}</span>
          </el-col>
        </template>
        <template slot="ProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.Product.Name}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.Product.Code}}</p>
        </template>
        <template slot="CustomerProductName" scope="props">
           <p class="no-margin">{{props.row.CustomerProductName | NullShow}}</p>
        <p class="no-margin">物料编码：{{props.row.CustomerProductCode | NullShow}}</p>
        </template>
        <template slot="ProductConditionName" scope="props">
          <el-tag :type="props.row.Condition.Name | ConditionColor">{{props.row.Condition.Name}}</el-tag>
        </template>
        <template slot="Brand" scope="props">
          {{props.row.Product.Brand.Name}}
        </template>
        <template slot="Model" scope="props">
          {{props.row.Product.Model.Name}}
        </template>
        <template slot="Module" scope="props">
          {{props.row.Product.Module.Name}}
        </template>
        <template slot="Quantity" scope="props">
          {{props.row.Quantity}}
        </template>
        <template slot="action-bar" scope="props">
        <el-button type="text" @click="goto({name: 'LeaseSentDetailOrder', params: {id: props.row.Id}})">查看</el-button>
        </template>
      </complex-grid>
    </div>
  </list-page-layout>
</template>

<script>
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        OrderCode: null,
        PartnerCode: null,
        OrderDateDuration: null,
        ShipmentMethod: null,
      },
      tableConfig: {
        dataPrefix: 'Lines',
        column: [
          {
            label: '物料名称',
            slot: 'ProductName',
          },
          {
            label: '客户物料名称',
            slot: 'CustomerProductName',
          },
          {
            label: '品项',
            width: '140px',
            slot: 'ProductConditionName',
          },
          {
            label: '品牌',
            slot: 'Brand',
            width: '100px',
          },
          {
            label: '机型',
            slot: 'Model',
            width: '120px',
          },
          {
            label: '模块',
            slot: 'Module',
            width: '80px',
          },
          {
            label: '数量',
            slot: 'Quantity',
            width: '80px',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '140px',
          },
        ],
      },
      IsLoading: false,
      tableData: [],
      currentTab: 'all',
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    goto(params) {
      window.localStorage.setItem('trustListFlag', 'self')
      this.$router.push(params)
    },
    handleTabClick({name}) {
      this.currentTab = name
      this.handleSearch()
    },
    handleChange(params) {
      this.currentPage = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch() {
      this.IsLoading = true
      const Query = o('ShipmentRequest')
      let filters = []
      Query.expand(`Partner($select=Id,Code,Name),Lines($expand=Lots($expand=Lot))`)
      if (this.currentTab !== 'all') {
        filters.push(`contains(State, '${this.currentTab}')`)
      }
      if (this.Search.OrderCode) {
        filters.push(`contains(Code, '${this.Search.OrderCode}')`)
      }
      if (this.Search.PartnerCode) {
        filters.push(`contains(Partner/Code, '${this.Search.PartnerCode}')`)
      }
      if (this.Search.ShipmentMethod) {
        filters.push(`Lines/any(p:contains(p/ShipmentMethod, '${this.Search.ShipmentMethod}'))`)
      }
      if (this.Search.Product) {
        filters.push(`Lines/any(p:contains(p/Product/Name, '${this.Search.Product}'))
        or
        Lines/any(p:contains(p/Product/Code, '${this.Search.Product}'))
        `)
      }
      if (this.Search.OrderDateDuration) {
        if (this.Search.OrderDateDuration[0] === null) {
          this.Search.OrderDateDuration === []
        } else {
          console.log(this.Search.OrderDateDuration)
          const startDate = this.$moment(this.Search.OrderDateDuration[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
          const endDate = this.$moment(this.Search.OrderDateDuration[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
          filters.push(`(OrderDate ge ${startDate}
          and OrderDate le ${endDate})`)
        }
      }
      if (filters.length > 0) {
        Query.filter(filters.join(' and '))
      }
      Query.inlineCount()
      Query.skip((this.currentPage - 1) * this.pageSize)
      Query.top(this.pageSize)
      Query.orderBy('OrderDate', 'desc').get().then(({data, inlinecount}) => {
        console.log(data)
        this.IsLoading = false
        this.tableData = data.map(item => {
          const LotList = []
          item.Lines.forEach(line => {
            line.Lots.forEach(Lot => {
              LotList.push(Lot)
            })
          })
          item.LotList = LotList
          return item
        })
        this.total = inlinecount
      }).finally(() => {
        this.IsLoading = false
      })
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
  },
  created() {
    this.handleSearch()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.status{
  color: red;
}
</style>



// WEBPACK FOOTER //
// LeaseSent_order.vue?4ce1c280